import React from 'react';

function SvgEchIconSocialMediaLinkedin2White(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <defs>
        <style>{'.cls-1{fill:#fff;}'}</style>
      </defs>
      <path
        className="cls-1"
        d="M65.12,31.82H35.34a3.29,3.29,0,0,0-3.29,3.29V64.89a3.29,3.29,0,0,0,3.29,3.29H65.12a3.29,3.29,0,0,0,3.29-3.29V35.11A3.29,3.29,0,0,0,65.12,31.82ZM43.3,63.22a1,1,0,0,1-.95,1H38.27a1,1,0,0,1-1-1V46.14a1,1,0,0,1,1-1h4.08a1,1,0,0,1,.95,1Zm-3-19.65a3.87,3.87,0,1,1,3.87-3.87A3.87,3.87,0,0,1,40.31,43.57ZM64.6,63.29a.88.88,0,0,1-.88.88H59.34a.88.88,0,0,1-.88-.88v-8c0-1.19.35-5.24-3.12-5.24-2.69,0-3.24,2.77-3.35,4v9.24a.87.87,0,0,1-.88.88H46.88a.87.87,0,0,1-.88-.88V46.06a.87.87,0,0,1,.88-.88h4.23a.87.87,0,0,1,.88.88v1.49c1-1.5,2.48-2.66,5.65-2.66,7,0,7,6.54,7,10.14v8.26Z"
      />
    </svg>
  );
}
export default SvgEchIconSocialMediaLinkedin2White;
